import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { exibirMensagem } from '../../redux/actions/mensagemAction';
import ambiente from '../../config/ambienteConfig';

class RegistroForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nome: '',
      email: '',
      senha: '',
      redirecionar: false,
    };
  }

  handleSave = async () => {
    try {
      await axios.post(`${ambiente.dev.server}/usuarios`, this.state);
      this.props.exibirMensagem('yay', 'Usuário adicionado com sucesso');
      this.setState({ redirecionar: true });
    } catch (err) {
      this.props.exibirMensagem('err', `Erro: ${err}`);
    }
  }

  render() {
    if(this.state.redirecionar) 
      return <Redirect to="/login" />;

    return (
      <div className="jumbotron">
        <div className="form-group">
            <input type="text" className="form-control" placeholder="Nome"
              value={this.state.nome} autoFocus
              onChange={evt => this.setState({ nome: evt.target.value })} />
        </div>
        <div className="form-group">
            <div className="input-group">
                <div className="input-group-addon">@</div>
                <input type="email" className="form-control" placeholder="Email"
                  value={this.state.email} 
                  onChange={evt => this.setState({ email: evt.target.value })} />
            </div>
        </div>
        <div className="form-group">
            <input type="password" className="form-control" placeholder="Senha"
              value={this.state.senha} 
              onChange={evt => this.setState({ senha: evt.target.value })} />
        </div>
        <button type="submit" className="btn btn-primary" onClick={this.handleSave}>
          Registrar
        </button>
      </div>
    );
  }
}

RegistroForm.propTypes = {
  exibirMensagem: PropTypes.func.isRequired
};

function mapStateToProps({nomeUsuario}) {
  return {
    nomeUsuario
  };
}

function mapDispatchToProps(dispatch) {
  return {
    exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistroForm);



// WEBPACK FOOTER //
// ./src/components/autenticacao/RegistroForm.js